import React, { useEffect, useState } from "react";
import SubscriptionDialog from "../../company/company-edit-Dialog/SubscriptionDialog";
import { i18n } from "../../private/languageSelector";
import { Modal, ModalBody } from "reactstrap";
import IconClose from "../../../../assets/img/close-homepage.svg";
import axios from "axios";

function ContactModal({ show, onHide }) {
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [isFormPartiallyFilled, setIsFormPartiallyFilled] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const resetForm = () => {
    setFormData({ name: "", email: "", mobile: "", message: "" });
    setEmailError("");
  };

  const handleFieldChange = (item, e) => {
    setFormData({ ...formData, [item]: e?.target?.value });
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    if (formData?.email?.length > 0 && formData?.name?.length > 0 && formData?.mobile?.length > 0 && formData?.message?.length > 0) {
      setIsFormFilled(true);
    } else setIsFormFilled(false);
    if (formData?.email?.length > 0 || formData?.name?.length > 0 || formData?.mobile?.length > 0 || formData?.message?.length > 0) {
      setIsFormPartiallyFilled(true);
    } else {
      setIsFormPartiallyFilled(false);
    }
  }, [formData]);

  const selectedLanguage = localStorage.getItem("language");

  const handleSubmit = () => {
    let dataToSend = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      messageContent: formData.message,
      language: selectedLanguage,
      subject: formData.name,
    };
    axios.post("/api/contact-email", dataToSend).then((res) => {
      if (res.status === 200) {
        onHide();
        resetForm();
        setShowSuccessModal(true);
        setEmailError("");
      }
    });
  };
  return (
    <div className="h-100 w-100 d-flex justify-content-center align-items-center">
      <Modal
        isOpen={show}
        toggle={() => {
          isFormPartiallyFilled ? setShowUnsavedChangesModal(true) : onHide();
          setEmailError("");
        }}
        //   className="plan-dialog modal-main"
        className="mx-auto my-auto modal centered-modal-main-content"
        centered
      >
        <ModalBody
          //  className="d-flex justify-content-center align-items-center flex-column p-6"
          style={{ background: "#E7F2FB", width: "100%", height: "100%", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}
        >
          <div className="">
            <div className={`${selectedLanguage === "arabic" ? "text-left" : "text-right"}  mt-4 `}>
              <img
                className="cursor-pointer"
                src={IconClose}
                alt="close"
                onClick={() => (isFormPartiallyFilled ? setShowUnsavedChangesModal(true) : onHide())}
                width={14}
                height={14}
              />
            </div>
            <div
              className={`mt-4 ${selectedLanguage === "arabic" ? "text-right" : "text-left"} `}
              style={{ width: "100%", height: "100%", borderBottom: "2px solid #349FDC" }}
            >
              <p style={{ color: "#349FDC", fontSize: 30 }}>{i18n("HomePage.Contact")}</p>
              <p className="py-4" style={{ color: "#4F4F4F", fontSize: "16px" }}>
                {i18n("HomePage.SubmitYourRequest")}
              </p>
            </div>

            <div className="mt-5 ">
              <form className="home-contact-modal-form">
                <div>
                  {" "}
                  <input
                    className="w-100 my-5 p-2 "
                    type="text"
                    placeholder={i18n("HomePage.Name")}
                    id="name"
                    value={formData?.name}
                    onChange={(e) => {
                      handleFieldChange("name", e);
                    }}
                  />
                </div>
                <div>
                  <input
                    className="w-100 my-5 p-2 "
                    type="email"
                    id="email"
                    placeholder={i18n("HomePage.Email")}
                    value={formData?.email}
                    onChange={(e) => {
                      handleFieldChange("email", e);
                      if (e?.target?.value?.length > 0 && emailError?.length > 0 && !validateEmail(formData.email)) {
                        setEmailError(i18n("Validation.InvalidEmail"));
                      } else {
                        setEmailError("");
                      }
                    }}
                    onBlur={() => {
                      if (!validateEmail(formData.email)) {
                        setEmailError(i18n("Validation.InvalidEmail"));
                      } else {
                        setEmailError("");
                      }
                    }}
                  />
                  <span className={`px-2 ${selectedLanguage==="arabic"?"float-right":"float-left"}`} style={{ color: "#f64e60", marginTop: "-0.4rem",marginBottom:"-0.4rem" }}>
                    {emailError?.length > 0 ? emailError : ""}
                  </span>
                </div>
                <div>
                  <input
                    className="w-100 my-5 p-2 "
                    type="text"
                    id="mobile"
                    placeholder={i18n("HomePage.Mobile")}
                    value={formData?.mobile}
                    onChange={(e) => handleFieldChange("mobile", e)}
                  />
                </div>

                <textarea
                  className="w-100 my-5 p-2 "
                  placeholder={i18n("HomePage.WriteYourRequest")}
                  rows={5}
                  value={formData?.message}
                  onChange={(e) => handleFieldChange("message", e)}
                  id="message"
                />
                <button
                  type="button"
                  className={` w-100 ${selectedLanguage === "arabic" ? "text-left" : "text-right"}  ${isFormFilled ? "active" : ""}`}
                  onClick={handleSubmit}
                  disabled={!isFormFilled || emailError?.length > 0}
                >
                  {i18n("ForgotPassword.Send")}
                </button>
              </form>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* success modal */}

      <Modal
        isOpen={showSuccessModal}
        toggle={() => setShowSuccessModal(false)}
        //   className="plan-dialog modal-main"
        className="mx-auto my-auto modal centered-modal-main-content full-heighted"
        centered
      >
        <ModalBody style={{ background: "#E7F2FB", width: "100%", height: "100%", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
          <div className="h-100">
            <div className="mt-5 h-100 d-flex flex-column">
              <div className="m-auto success-text">{i18n("HomePage.SentSuccessfully")}</div>
              <button
                type="button"
                className={` close-button w-100 ${selectedLanguage === "arabic" ? "text-left" : "text-right"}`}
                style={{ color: "#828282" }}
                onClick={() => setShowSuccessModal(false)}
              >
                {i18n("SubscriptionModals.CLOSE")}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* unsaved changes modal */}
      <SubscriptionDialog
        modalWidth={"350px"}
        modalHeight={"185px"}
        modalBackgroundColor={"#FFFFFF"}
        show={showUnsavedChangesModal}
        onHide={() => setShowUnsavedChangesModal(false)}
        title={"unsent data"}
        titleWidth={"140px"}
        titleHeight={"20px"}
        titleFontWeight={"700"}
        titleFontSize={"16px"}
        titleLineHeight={"20px"}
        titleColor={"#333333"}
        message={"Closing the window will result in the loss of the data you entered. Are you sure you want to close the window?"}
        messageWidth={"320px"}
        messageHeight={"54px"}
        messageFontSize={"16px"}
        messageFontWeight={"400"}
        messageLineHeight={"21.79px"}
        messageColor={"#333333"}
        primaryLabel={i18n("SubscriptionModals.CANCEL")}
        primaryAction={() => setShowUnsavedChangesModal(false)}
        primaryLabelWidth={"55px"}
        primaryLabelHeight={"20px"}
        primaryLabelFontWeight={"700"}
        primaryLabelFontSize={"14px"}
        primaryLabelLineHeight={"20px"}
        primaryLabelColor={"#828282"}
        secondaryAction={() => {
          setShowUnsavedChangesModal(false);
          onHide();
          setIsFormFilled(false);
          resetForm();
        }}
        secondaryLabel={"Yes, close window"}
        secondaryLabelWidth={"auto"}
        secondaryLabelHeight={"20px"}
        secondaryLabelFontWeight={"700"}
        secondaryLabelFontSize={"14px"}
        secondaryLabelLineHeight={"20px"}
        secondaryLabelColor={"#2D9CDB"}
        isCenteredOnMobile
      />
    </div>
  );
}

export default ContactModal;
